import { call, put } from 'redux-saga/effects';
import { requestFailed } from '~src/app/actions/RequestFailedAction';
import { requestSpaceContents } from '~src/app/actions/spaces/RequestSpaceContentsActions';
import { SetTagsAction } from '~src/app/actions/spaces/SetTagsActions';
import {
    reloadSpaceIfUpdatingCurrentSpace
} from '~src/app/sagas/spaces/content/RefreshContentSagas';
import {
    replaceDatasourceIdWithConnectionIdForMixedContent
} from '~src/app/sagas/spaces/SpacesSagaHelpers';
import { Messages } from '~src/codegen/Localize';
import { ChangeContentTagsAction } from '~src/content/services/ChangeContentTagsAction';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IContentInfo } from '~src/ts/models/IContentInfo';

export function* handleSetTags(action: SetTagsAction) {
  try {
    //Hack to mitigate Datasource API expecting DataConnectionId
    let mutatableContentCopy: IContentInfo[] = [];
    mutatableContentCopy = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, action.content);
    //endHack

    yield call(changeContentTags, mutatableContentCopy);

    // reload the space if we changed its tags so that opening the tags dialog again will have the updated tags info
    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, action.content);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function changeContentTags(contentCollection: IContentInfo[]): Promise<IResult> {
  return ChangeContentTagsAction.showChangeTagsForMixedContentDialog(contentCollection);
}
